routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
     .state('home.procedureDetail', {
       url: "procedure-detail/",
       template: `<procedure-detail sh-ctrl="shCtrl"></procedure-detail>`
    })
    .state('home.procedureDetailSlug', {
      url: "procedure-detail-slug/{procedureSlug}",
      template: `<procedure-detail sh-ctrl="shCtrl"></procedure-detail>`
    })
    .state('home.procedureDetailId', {
      url: "procedure-detail-id/{procedureId}",
      template: `<procedure-detail sh-ctrl="shCtrl"></procedure-detail>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/procedure-detail/procedure-detail.config.js
 **/